import * as React from 'react';
import Grid from '@mui/material/Grid';
import { Divider, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(function (theme) {
  return {
    gridContainer: {
      [theme.breakpoints.up("sm")]: {
        paddingLeft: '100px',
        paddingRight: '100px'
      },
      [theme.breakpoints.up("md")]: {
        paddingLeft: '150px',
        paddingRight: '150px'
      },
      [theme.breakpoints.up("lg")]: {
        paddingLeft: '200px',
        paddingRight: '200px'
      },
      [theme.breakpoints.only("xl")]: {
        paddingLeft: ' 300px',
        paddingRight: '300px'
      },
    },
  };
});

const titleStyle = { textAlign: 'center' };
const textWidth = { maxWidth: '350px' };
const divideStyle = { textAlign: 'center', mt: 3 };
const container = { mt: 2 };
const imgStyle = { maxWidth: '80%' }

export default function InputElectric() {
  const classes = useStyles();
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <React.Fragment>
      <Typography variant="h3" gutterBottom sx={titleStyle}>Issuer</Typography>
      <Typography variant="h3" gutterBottom sx={titleStyle}>Vietnam Electricity Corporation (EVN)</Typography>
      <Grid container spacing={3} sx={container} justifyContent="center" alignItems="center" className={classes.gridContainer} >
        <Grid item xs={12} sx={titleStyle}>
          <TextField
            fullWidth
            variant="outlined"
            label="Customer Code"
            sx={textWidth}
          />
        </Grid>
      </Grid>
      <Divider sx={divideStyle} className={classes.gridContainer} />
      <Grid container spacing={1} sx={container} justifyContent="center" alignItems="center" className={classes.gridContainer} >
        <Grid item xs={12} sx={titleStyle}>
          <Typography variant="h5" gutterBottom sx={{ textAlign: 'center', mb: `${matchDownSM ? '1' : '3'}` }}>
            Actively pay electricity bills in 63 provinces/cities. Pay anytime, anywhere.            <br />
            Simple - Fast - Accurate         </Typography>
        </Grid>
        <Grid item xs={12} sx={titleStyle}>
          <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', mb: `${matchDownSM ? '1' : '3'}` }}>
            Electricity bill example:          </Typography>
        </Grid>
        <Grid item xs={12} sx={titleStyle}>
          <img src={process.env.PUBLIC_URL + '/assets/images/bill/electric.jpg'} alt="Electricity" style={imgStyle} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}